(function() {
    'use strict';

    angular.module('app').filter('dateChange', function() {

        return function(value, years, months, days) {
            var dateValue = new Date(value);
            var year = dateValue.getFullYear();
            var month = dateValue.getMonth();
            var day = dateValue.getDate();
            var newDate = new Date(year + (years ? years : 0), month + (months ? months : 0), day + (days ? days : 0));
            return newDate;
        }
    });

}());